import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment";
import "moment-duration-format";

@Pipe({ name: "sToHHMMSSPipe" })
export class SToHHMMSSPipe implements PipeTransform {
  transform(value: string) {
    const valueDuration = moment.duration(value, "seconds");

    let formattedValue = valueDuration.format("hh:mm:ss");

    if (formattedValue.length === 2) {
      formattedValue = `00:${formattedValue}`;
    }

    return formattedValue;
  }
}
